export enum AiState {
  DEFAULT = 'default',
  ANALYZING = 'analyzing',
  GENERATING = 'generating'
}
